import Head from "next/head";
import { PartnerLayout, Partners } from "views/Main/PartnerLayout";
import { Supplier } from "views/Main/Tabs";

export default function SupplierPartner() {
  return (
    <>
      <Head>
        <title>자재공급사 | 빌더허브 파트너스</title>
      </Head>
      <PartnerLayout partner={Partners.supplier}>
        <Supplier />
      </PartnerLayout>
    </>
  );
}
